import { render } from "./SeparateRecommendedTest.vue?vue&type=template&id=0d2e74c6&scoped=true"
import script from "./SeparateRecommendedTest.vue?vue&type=script&lang=js"
export * from "./SeparateRecommendedTest.vue?vue&type=script&lang=js"

import "./SeparateRecommendedTest.vue?vue&type=style&index=0&id=0d2e74c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2e74c6"]])

export default __exports__